import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const mandateApi = createAsyncThunk(
  "mandate",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/mandate", { params });
    return response.data;
  }
);

const mandateSlice = createSlice({
  name: "mandate",
  initialState: {
    mandate: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mandateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(mandateApi.fulfilled, (state, action) => {
        state.mandate = action.payload;
        state.loading = false;
      })
      .addCase(mandateApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default mandateSlice.reducer;
